import React, { useEffect, useState } from 'react';
import { Drawer, List, ListItem, ListItemText, Toolbar, AppBar, Typography, IconButton,
  Divider, Box,Collapse,Button } from '@mui/material';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/SFooter';
import ShipperGuidelines from './ShipperGuidelines';
import ShipperForm from './ShipperForm';
import ShipperRequest from './ShipperRequest';
import DriverPolicyPage from './DriverPolicyPage';
import { saveShipperInfo, getvehicleType, fetchShipperInfo } from '../service/shipperService';

const drawerWidth = 240;

export default function ShipperDashboard() {

  const [selectedMenu, setSelectedMenu] = useState('Dashboard');
  const [existingShipper, setExistingShipper] = useState(null);

    
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
    
 const { user, logout } = useAuth();
  const {
    email,
    name,
    familyName,
    givenName,
    userId,
    roles, 
    userTypes,
    partnerId,
    emailVerified,
  } = user || {};

  const toggleDrawer = () => {
    setOpen(!open);
  };
  
    const handleLogout = () => {
    logout(); 
     navigate('/shipperlogin');

  };
    
    
  useEffect(() => {

 fetchShipper();
  }, []);
  
   
   const fetchShipper = async () => {
    
    try {
      const res = await fetchShipperInfo(user.userId); //axiosInstance.get("/api/zones");
      setExistingShipper(res.data);
      
      console.log(res.data.isApproved);
    //  setFormData({vehicleTypeId: res.data.vehicleTypeId});
    } catch (err) {
      console.error("Error fetching shiooer:", err);
    }
   
  }; 

  if (user === null) {
    return <div>Loading...</div>; 
  }
  
   
  if (!user) {
   // return <SupplierStepper />; // Supplier info not completed yet
      
       navigate('/shipperlogin');
  }
  
    

  // Supplier exists, show full dashboard
  const renderContent = () => {
    switch (selectedMenu) {
      case 'Shipper Info':
        return <ShipperForm  initialData={existingShipper} />;
    case 'Shipper Request':
        return <ShipperRequest />;
    case 'Delivery Policy':
        return <DriverPolicyPage />
      default:
        return <ShipperGuidelines setSelectedMenu={setSelectedMenu} />;
    }
  };

  return (

   <>
  <AppBar position="static" sx={{ bgcolor: '#4D7B2B', color: '#FFFFFF' }}>
  <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
    {/* Title */}
    <Typography variant="h6" component="div">
      {selectedMenu === "Dashboard" ? "Dashboard" : selectedMenu}
    </Typography>

    <Box
            component="img"
            src="../images/foodsakzsidegraylogo.png" 
            alt="FoodSakz Logo"  
            sx={{ 
              height: 60,
              cursor: "pointer",
            }}
            onClick={() => navigate("/supplierdashboard")}
           />
  </Toolbar>
</AppBar>
        <Box sx={{ display: "flex", minHeight: "100vh", flexDirection: "column" }}>
  

<Box sx={{ display: "flex" }}>
      {/* Sidebar with toggle arrow */}
      <Collapse in={open} orientation="horizontal">
        <Box
          sx={{
            width: 250,
            borderRight: "1px solid #ddd",
            position: "relative",
            backgroundColor: "#fafafa",
            height: "100vh"
          }}
        >
         {/* Drawer */}
  <Drawer
    variant="persistent"
    anchor="left"
    open={open}
    sx={{
      width: drawerWidth,
      flexShrink: 0,
      "& .MuiDrawer-paper": {
        width: drawerWidth,
        boxSizing: "border-box",
        top: { xs: "56px", sm: "64px" }, // below AppBar
        height: { xs: "calc(100% - 56px)", sm: "calc(100% - 64px)" }
      }
    }}
  >
    <Typography variant="h6" component="div">
        Welcome {name}
    </Typography>
    <Button variant="outlined" color="inherit" onClick={handleLogout}
   sx={{
                  marginTop: 2,
                  backgroundColor: '#F1B94C',
                  color: '#2C2E2F',
                  fontWeight: 'semibold',
                  '&:hover': {
                    backgroundColor: '#49A39D',
                  },
                }}
>
          Logout
        </Button>
    <Divider />
        <List>
          {['Dashboard', 'Shipper Info', 'Shipper Request','Delivery Policy'].map((text) => (
            <ListItem button key={text} onClick={() => setSelectedMenu(text)}>
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </List>
      </Drawer>

          {/* Arrow button inside sidebar */}
          <IconButton
            onClick={toggleDrawer}
            sx={{
              position: "absolute",
              top: "50%",
              right: -20,
              transform: "translateY(-50%)",
              backgroundColor: "white",
              border: "1px solid #ccc",
              "&:hover": { backgroundColor: "#f0f0f0" }
            }}
            size="small"
          >
            <ChevronLeftIcon />
          </IconButton>
        </Box>
      </Collapse>

      {/* Collapsed toggle button */}
      {!open && (
        <IconButton
          onClick={toggleDrawer}
          sx={{
            position: "relative",
            backgroundColor: "white",
            border: "1px solid #ccc",
            height: "40px",
            marginTop: "20px",
            "&:hover": { backgroundColor: "#f0f0f0" }
          }}
          size="small"
        >
          <ChevronRightIcon />
        </IconButton>
      )}
      <Box component="main"  sx={{
              flexGrow: 1,
              p: 3,
              transition: "margin 0.3s",
              marginLeft: open ? `${drawerWidth}px` : "0px",
            }}>
        <Toolbar />
        {renderContent()}
      </Box>
    </Box>
           <Footer />
     </Box>
</>
     
  );
}